import { Flex } from '@vtex/admin-ui'
import { FormattedMessage, FormattedNumber } from 'react-intl'
import { Restrictions as RestrictionsType } from 'typings'
import { SummaryRow, Tag } from 'ui'
import { messages } from '../messages'
import styles from './styles'
import { RestrictionsMap } from 'ui/components/PromotionForm/Restrictions/typings'

type Props = {
  restrictions: Pick<Partial<RestrictionsType>, RestrictionsMap>
}

function MaxUsageRow(props: { maxUsage: RestrictionsType['maxUsage'] }) {
  const { maxUsage } = props

  if (!maxUsage) return null

  return (
    <Flex className={styles.flexRow}>
      <Tag>
        <FormattedNumber value={maxUsage} />
      </Tag>
      <FormattedMessage {...messages.restrictions.maxUsage} />
    </Flex>
  )
}

function MaxUsagePerClientRow(props: {
  maxUsagePerClient: RestrictionsType['maxUsagePerClient']
}) {
  const { maxUsagePerClient } = props

  if (!maxUsagePerClient) return null

  return (
    <Flex className={styles.flexRow}>
      <Tag>
        <FormattedNumber value={maxUsagePerClient} />
      </Tag>
      <FormattedMessage {...messages.restrictions.maxUsagePerClient} />
    </Flex>
  )
}

function MaxItemsPerCartRow(props: {
  maxItemsPerCart: RestrictionsType['maxItemsPerCart']
}) {
  const { maxItemsPerCart } = props

  if (!maxItemsPerCart) return null

  return (
    <Flex className={styles.flexRow}>
      <Tag>
        <FormattedNumber value={maxItemsPerCart.value} />
      </Tag>
      <FormattedMessage {...messages.restrictions.maxItemsPerCart} />
    </Flex>
  )
}

function MaxItemsPerAttributeRow(props: {
  maxItemsPerAttribute: RestrictionsType['maxItemsPerAttribute']
}) {
  const { maxItemsPerAttribute } = props

  if (!maxItemsPerAttribute) return null

  return (
    <Flex className={styles.flexRow}>
      <Tag>
        <FormattedNumber value={maxItemsPerAttribute.value} />
      </Tag>
      <FormattedMessage
        {...messages.restrictions.maxItemsPerAttribute}
        values={{ attribute: maxItemsPerAttribute.attribute }}
      />
    </Flex>
  )
}

export function RestrictionsRow(props: Props) {
  const {
    restrictions: {
      maxUsage,
      maxUsagePerClient,
      maxItemsPerCart,
      maxItemsPerAttribute,
    },
  } = props

  const emptyRestrictions = [
    maxUsage,
    maxUsagePerClient,
    maxItemsPerCart,
    maxItemsPerAttribute,
  ].every((restriction) => !restriction)

  return (
    <SummaryRow>
      <SummaryRow.Title>
        <FormattedMessage id="admin/promotions.form.restrictions.title" />
      </SummaryRow.Title>
      <SummaryRow.Value className={styles.valueContentColumn}>
        {emptyRestrictions && (
          <FormattedMessage {...messages.restrictions.empty} />
        )}

        <MaxUsageRow maxUsage={maxUsage} />
        <MaxUsagePerClientRow maxUsagePerClient={maxUsagePerClient} />
        <MaxItemsPerCartRow maxItemsPerCart={maxItemsPerCart} />
        <MaxItemsPerAttributeRow maxItemsPerAttribute={maxItemsPerAttribute} />
      </SummaryRow.Value>
    </SummaryRow>
  )
}
